<nb-card class="lti-connect">
  <nb-card-header>
    <div class="lti-connect__head">
      <div>
        <h4>{{ 'dialogs.ltiConnect.title' | translate }}</h4>
        <p class="lti-connect__hint">{{ 'dialogs.ltiConnect.hint' | translate }}</p>
      </div>
      <button
        nbButton
        ghost
        status="basic"
        size="small"
        [attr.aria-label]="'buttons.close' | translate"
        (click)="close()"
      >
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>

  <nb-card-body>
    <!-- ── Neue Verbindung ─────────────────────────────────────── -->
    <section class="settings-group">
      <p class="settings-group__title">{{ 'dialogs.ltiConnect.addTitle' | translate }}</p>

      <div *ngIf="!activeChoice" class="lms-choices">
        <button
          *ngFor="let choice of choices"
          type="button"
          class="lms-choice"
          (click)="chooseLms(choice)"
        >
          <img [src]="choice.image" alt="" class="lms-choice__logo" />
          <span class="lms-choice__body">
            <span class="lms-choice__name">
              {{ 'dialogs.ltiConnect.choices.' + choice.key + '.name' | translate }}
              <span *ngIf="choice.beta" class="state-chip is-warning">
                {{ 'dialogs.ltiConnect.beta' | translate }}
              </span>
            </span>
            <span class="lms-choice__desc">
              {{ 'dialogs.ltiConnect.choices.' + choice.key + '.desc' | translate }}
            </span>
          </span>
        </button>
      </div>

      <!-- Dynamische Registrierung: Formular + URL + Anleitung -->
      <div *ngIf="activeChoice" class="issue">
        <div class="issue__head">
          <button
            type="button"
            class="issue__back"
            [attr.aria-label]="'buttons.back' | translate"
            [nbTooltip]="'buttons.back' | translate"
            nbTooltipPlacement="top"
            (click)="cancelChoice()"
          >
            <nb-icon icon="arrow-back-outline"></nb-icon>
          </button>
          <img [src]="activeChoice.image" alt="" class="issue__logo" />
          <h5>{{ 'dialogs.ltiConnect.choices.' + activeChoice.key + '.name' | translate }}</h5>
        </div>

        <!-- Eingeklappt, aber vor dem Formular: wer die Schritte erst nach dem
             Erzeugen der URL fände, hätte sich schon entschieden. -->
        <div class="guide-box" [class.is-open]="guideOpen">
          <button type="button" class="guide-box__head" (click)="toggleGuide()">
            <nb-icon icon="book-open-outline" class="guide-box__icon"></nb-icon>
            <span class="guide-box__label">
              {{ 'dialogs.ltiConnect.guideTitle' | translate: { count: guideStepNumbers.length } }}
            </span>
            <nb-icon
              class="guide-box__chevron"
              [icon]="guideOpen ? 'chevron-up-outline' : 'chevron-down-outline'"
            ></nb-icon>
          </button>

          <div *ngIf="guideOpen" class="guide-box__body">
            <ol class="guide">
              <li *ngFor="let step of guideStepNumbers">
                {{ 'dialogs.ltiConnect.guide.' + activeChoice.key + '.s' + step | translate }}
              </li>
            </ol>

            <!-- Versionshinweis: bei ILIAS entscheidet die Version, ob der
                 automatische Weg überhaupt zur Verfügung steht. -->
            <p *ngIf="activeChoice.key === 'ilias'" class="issue__caveat">
              {{ 'dialogs.ltiConnect.guide.ilias.caveat' | translate }}
            </p>

            <!-- Querverweis: LTI und Datenabgleich sind zwei Schritte. Wer nur
                 den Agent im Kurs will, hört hier auf; wer Kurslisten und
                 Lernstände braucht, findet den zweiten Schritt ohne Suche. -->
            <p *ngIf="activeChoice.key === 'ilias'" class="issue__crosslink">
              {{ 'dialogs.ltiConnect.iliasSyncHint' | translate }}
              <a href="javascript:void(0)" (click)="goToIliasSync()">
                {{ 'dialogs.ltiConnect.iliasSyncLink' | translate }}
              </a>
            </p>
          </div>
        </div>

        <div *ngIf="!issuedUrl" class="issue__form">
          <div class="field">
            <label class="field__label" for="lti-label">
              {{ 'dialogs.ltiConnect.field.label' | translate }}
            </label>
            <input
              id="lti-label"
              nbInput
              fullWidth
              fieldSize="small"
              [(ngModel)]="label"
              [placeholder]="
                'dialogs.ltiConnect.field.labelPlaceholder.' + activeChoice.key | translate
              "
            />
          </div>

          <div class="field">
            <label class="field__label">
              {{ 'dialogs.ltiConnect.field.environment' | translate }}
            </label>
            <nb-select fullWidth size="small" [(ngModel)]="environment">
              <nb-option value="production">
                {{ 'dialogs.ltiConnect.environment.production' | translate }}
              </nb-option>
              <nb-option value="staging">
                {{ 'dialogs.ltiConnect.environment.staging' | translate }}
              </nb-option>
            </nb-select>
            <p class="field__help">{{ 'dialogs.ltiConnect.field.environmentHint' | translate }}</p>
          </div>

          <button nbButton status="primary" size="small" [disabled]="issuing" (click)="issueUrl()">
            <nb-icon icon="link-2-outline"></nb-icon>
            {{ (issuing ? 'buttons.saving' : 'dialogs.ltiConnect.issueUrl') | translate }}
          </button>
        </div>

        <div *ngIf="issuedUrl" class="issue__result">
          <div class="url-row">
            <code class="url-row__value">{{ issuedUrl }}</code>
            <button
              nbButton
              ghost
              size="small"
              status="primary"
              (click)="copy(issuedUrl, $event)"
            >
              {{ 'buttons.copy' | translate }}
            </button>
          </div>
          <p class="issue__once">{{ 'dialogs.ltiConnect.urlOnce' | translate }}</p>

          <button nbButton ghost size="small" status="basic" (click)="reload()">
            <nb-icon icon="refresh-outline"></nb-icon>
            {{ 'dialogs.ltiConnect.checkNow' | translate }}
          </button>
        </div>

        <div *ngIf="errorMessage" class="lti-connect__error">{{ errorMessage }}</div>
      </div>
    </section>

    <!-- ── Bestehende Verbindungen ────────────────────────────── -->
    <div *ngIf="loading" class="lti-connect__loading">
      <nb-spinner status="basic"></nb-spinner>
    </div>

    <div *ngIf="!loading && registrations.length === 0" class="lti-connect__empty">
      <p>{{ 'dialogs.ltiConnect.empty' | translate }}</p>
    </div>

    <div
      *ngFor="let reg of registrations; trackBy: trackReg"
      class="moodle-site-row"
    >
      <div class="moodle-site-tile__header">
        <span class="moodle-site-tile__favicon">
          <nb-icon icon="link-2-outline"></nb-icon>
        </span>
        <div class="moodle-site-tile__identity-wrap">
          <a
            class="moodle-site-tile__identity"
            [href]="reg.lti_issuer"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span class="moodle-site-tile__domain">
              {{ reg.display_name }}
              <nb-icon icon="external-link-outline"></nb-icon>
            </span>
            <span class="moodle-site-tile__url">{{ issuerHost(reg) }}</span>
          </a>
        </div>
        <span
          class="moodle-site-tile__status-dot"
          [class.is-connected]="statusOf(reg) === 'success'"
          [class.is-warning]="statusOf(reg) === 'warning'"
          [class.is-danger]="statusOf(reg) === 'danger'"
          [attr.aria-label]="statusKey(reg) | translate"
          role="status"
        ></span>
      </div>

      <div class="moodle-site-row__meta">
        <span
          class="state-chip"
          [class.is-connected]="statusOf(reg) === 'success'"
          [class.is-warning]="statusOf(reg) === 'warning'"
          [class.is-danger]="statusOf(reg) === 'danger'"
        >
          {{ statusKey(reg) | translate }}
        </span>
        <span class="state-chip" [class.is-staging]="reg.environment === 'staging'">
          {{ 'dialogs.ltiConnect.environment.' + (reg.environment || 'production') | translate }}
        </span>
        <span *ngIf="platformLabel(reg)" class="state-chip">{{ platformLabel(reg) }}</span>
        <span *ngIf="reg.lti_registration_mode" class="state-chip">
          {{ 'dialogs.ltiConnect.mode.' + reg.lti_registration_mode | translate }}
        </span>
        <span *ngIf="reg.lti_deployment_id" class="state-chip">
          {{ 'dialogs.ltiConnect.deployment' | translate }} {{ reg.lti_deployment_id }}
        </span>
      </div>

      <div
        *ngIf="reg.lti_last_launch_error"
        class="moodle-site-info moodle-site-info--danger"
      >
        <nb-icon icon="alert-triangle-outline" status="danger"></nb-icon>
        <div class="moodle-site-info__body">
          <strong>{{ 'dialogs.ltiConnect.lastLaunchError' | translate }}</strong>
          <p>{{ reg.lti_last_launch_error }}</p>
          <small *ngIf="reg.lti_last_launch_error_at">
            {{ reg.lti_last_launch_error_at | date: 'short' }}
          </small>
        </div>
      </div>

      <div class="moodle-site-settings">
        <div class="settings-row">
          <span class="settings-row__label">
            {{ (isPaused(reg) ? 'dialogs.ltiConnect.resume' : 'dialogs.ltiConnect.pause') | translate }}
          </span>
          <button
            nbButton
            ghost
            size="small"
            status="basic"
            [disabled]="busyId === reg.id || isDisconnected(reg)"
            (click)="togglePause(reg)"
          >
            <nb-icon [icon]="isPaused(reg) ? 'play-circle-outline' : 'pause-circle-outline'"></nb-icon>
          </button>
        </div>

        <div class="settings-row">
          <span class="settings-row__label">{{ 'dialogs.ltiConnect.refresh' | translate }}</span>
          <button
            nbButton
            ghost
            size="small"
            status="basic"
            [disabled]="busyId === reg.id || !canRefresh(reg)"
            [nbTooltip]="'dialogs.ltiConnect.refreshManualHint' | translate"
            [nbTooltipDisabled]="canRefresh(reg)"
            nbTooltipPlacement="top"
            (click)="refresh(reg)"
          >
            <nb-icon icon="sync-outline"></nb-icon>
          </button>
        </div>

        <div class="settings-row">
          <span class="settings-row__label">{{ 'dialogs.ltiConnect.showUrls' | translate }}</span>
          <button nbButton ghost size="small" status="basic" (click)="toggleUrls(reg)">
            <nb-icon [icon]="urlsOpenFor === reg.id ? 'chevron-up-outline' : 'chevron-down-outline'"></nb-icon>
          </button>
        </div>

        <div *ngIf="urlsOpenFor === reg.id" class="url-list">
          <div *ngFor="let row of toolUrls(reg)" class="url-row">
            <span class="url-row__label">{{ row.labelKey | translate }}</span>
            <code class="url-row__value">{{ row.value }}</code>
            <button nbButton ghost size="small" status="primary" (click)="copy(row.value, $event)">
              {{ 'buttons.copy' | translate }}
            </button>
          </div>
        </div>
      </div>

      <div class="moodle-site-row__actions">
        <button
          nbButton
          ghost
          size="small"
          status="basic"
          class="btn-caution"
          [disabled]="busyId === reg.id || isDisconnected(reg)"
          [nbTooltip]="'dialogs.ltiConnect.disconnectTooltip' | translate"
          nbTooltipPlacement="top"
          (click)="disconnect(reg)"
        >
          <nb-icon icon="unlock-outline"></nb-icon>
          {{ 'dialogs.ltiConnect.disconnect' | translate }}
        </button>
        <button
          nbButton
          ghost
          size="small"
          status="danger"
          [disabled]="busyId === reg.id"
          (click)="remove(reg)"
        >
          <nb-icon icon="trash-2-outline"></nb-icon>
          {{ 'buttons.delete' | translate }}
        </button>
      </div>
    </div>
  </nb-card-body>
</nb-card>
